export default __webpack_public_path__ + "static/media/TaskList.a9f66e77.PNG";